/* eslint-disable no-console */
/**
 * App logger — active in development, no-op in production so request/response
 * payloads and other debug output never leak to the browser console in prod.
 */
const isDev = process.env.NODE_ENV !== "production";

const noop = () => {};

const logger = {
  log: isDev ? (...args) => console.log(...args) : noop,
  info: isDev ? (...args) => console.info(...args) : noop,
  warn: isDev ? (...args) => console.warn(...args) : noop,
  error: isDev ? (...args) => console.error(...args) : noop,
  debug: isDev ? (...args) => console.debug(...args) : noop,
  trace: isDev ? (...args) => console.trace(...args) : noop,
};

export default logger;
